import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseCommentsConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/services/fp-logger-noise-comments-connect.service';
import { FpLoggerNoiseCommentsStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/services/fp-logger-noise-comments/fp-logger-noise-comments.store';

export function fpLoggerNoiseCommentsProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseCommentsStore,
    FpLoggerNoiseCommentsConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseCommentsConnectService,
      multi: true,
    },
  ];
}
